import { createFileRoute, redirect } from '@tanstack/react-router';
import { SWEEP_ORDER_BASE_PATH } from '../../../../../../../../features/sweeps/clearing/order/sweep-order-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/')({
  beforeLoad: () => {
    throw redirect({ to: SWEEP_ORDER_BASE_PATH });
  },
  preload: false,
});
